import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import useApi from "../../hook/useApi";
import Paggination from "../../components/Paggination";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { CURRENCY_CODE, REFUND_STATUS } from "../../utils/constant";

const EsimBookingListLayer = () => {
  const { AsyncGetApiCall } = useApi();
  const navigate = useNavigate();

  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    refundStatus: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getAllBookingList = async () => {
    setLoading(true);
    try {
      const result = await AsyncGetApiCall("/esim/admin/list", query);
      if (result?.success) {
        setData(result.data || []);
        setPagination(result.pagination || null);
      } else {
        setData([]);
        setPagination(null);
      }
    } catch (error) {
      console.error("Error fetching eSIM bookings:", error);
      setData([]);
      setPagination(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllBookingList();
  }, [query]);

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({ ...prev, pageNo }));
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12 overflow-hidden">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-nowrap gap-3 w-100">
            <form className="navbar-search" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                className="bg-base h-40-px w-full"
                name="search"
                placeholder="Search by order/package/email"
                value={query.search}
                onChange={(e) =>
                  setQuery((prev) => ({
                    ...prev,
                    search: e.target.value,
                    pageNo: 1,
                  }))
                }
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>

            <span className="text-md fw-medium text-secondary-light mb-0 whitespace-nowrap ms-auto">
              Show
            </span>
            <select
              className="form-select w-auto form-select-sm ps-12 py-6 radius-12 h-40-px"
              value={query.limitVal}
              onChange={(e) =>
                setQuery((prev) => ({
                  ...prev,
                  limitVal: parseInt(e.target.value, 10),
                  pageNo: 1,
                }))
              }
            >
              {Array.from({ length: 20 }, (_, i) => {
                const value = (i + 1) * 5;
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>

            <select
              className="form-select w-auto form-select-sm ps-12 py-6 radius-12 h-40-px"
              value={query.refundStatus || "Select Refund Status"}
              onChange={(e) =>
                setQuery((prev) => ({
                  ...prev,
                  refundStatus:
                    e.target.value === "Select Refund Status" ? "" : e.target.value,
                  pageNo: 1,
                }))
              }
            >
              <option value="Select Refund Status">Select Refund Status</option>
              <option value="completed">Completed</option>
              <option value="pending">Pending</option>
              <option value="not_applicable">Not Applicable</option>
              <option value="failed">Failed</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
        </div>

        <div className="card-body p-24 d-flex flex-column overflow-hidden">
          <div className="table-responsive flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 270px)" }}>
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">Order Id</th>
                  <th scope="col">Package</th>
                  <th scope="col">Email</th>
                  <th scope="col">Currency</th>
                  <th scope="col">Price</th>
                  <th scope="col">Created At</th>
                  <th scope="col" className="text-center">Refund Status</th>
                  <th scope="col" className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ? (
                  data.map((item, index) => {
                    const esim = item?.eSimBookings?.[0] || {};
                    return (
                      <tr key={item._id}>
                        <td>{(pagination?.currentPage - 1) * query.limitVal + index + 1}</td>
                        <td>{item?.orderIdStr || item?.orderId || "N/A"}</td>
                        <td>{esim?.package_id || esim?.code || "N/A"}</td>
                        <td>{item?.user?.email || "N/A"}</td>
                        <td>{item?.bookingCurrency || esim?.currency || "N/A"}</td>
                        <td>
                          {`${CURRENCY_CODE[item?.bookingCurrency || esim?.currency] || ""} ${
                            Number(item?.bookingPrice || esim?.price || 0).toFixed(2)
                          }`}
                        </td>
                        <td>
                          {new Date(item.createdAt).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            dateStyle: "short",
                            timeStyle: "short",
                          })}
                        </td>
                        <td className="text-center">
                          <span
                            className={`badge ${
                              item?.refundStatus === "completed"
                                ? "bg-success-100 text-success-600"
                                : item?.refundStatus === "pending"
                                  ? "bg-warning-100 text-warning-600"
                                  : item?.refundStatus === "not_applicable"
                                    ? "bg-primary-300 text-secondary-600"
                                    : item?.refundStatus === "failed" || item?.refundStatus === "rejected"
                                      ? "bg-danger-100 text-danger-600"
                                      : "background-gray-100"
                            } text-sm py-4 px-10 radius-4`}
                          >
                            {REFUND_STATUS[item?.refundStatus] || "None"}
                          </span>
                        </td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => navigate(`/esim-booking/view-booking/${item._id}`)}
                          >
                            <Icon icon="majesticons:eye-line" className="icon text-xl" />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">No data found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <Paggination
            total={pagination?.total || 0}
            totalPages={pagination?.totalPages || 0}
            currentPage={pagination?.currentPage || 1}
            setPageNo={setPageNo}
            startFrom={(pagination?.currentPage - 1) * query.limitVal + 1}
            endTo={data?.length ? (pagination.currentPage - 1) * query.limitVal + data.length : 0}
          />
        </div>
      </div>
    </>
  );
};

export default EsimBookingListLayer;
